import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	OnInit,
	Output,
	signal,
	WritableSignal
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxI18nService } from '@studiohyperdrive/ngx-i18n';

import { CypressTagDirective } from '@cjm/cypress/core';
import { TagGroupComponent, TagComponent } from '@cjm/shared/ui/common';

import { AssociationTargetAudienceEntity, AssociationTargetAudience } from '../../../data';
import { I18nKeys } from '../../../i18n';

@Component({
	selector: 'vloket-association-target-audience-tags',
	templateUrl: './association-target-audience-tags.component.html',
	styleUrls: ['./association-target-audience-tags.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TagGroupComponent, TagComponent, TranslateModule, CypressTagDirective]
})
export class AssociationTargetAudienceTagsComponent implements OnInit {
	@HostBinding('class.c-association-target-audience-tags') private readonly hasRootClass: boolean = true;
	@HostBinding('attr.aria-live') public ariaLive: string = 'polite';
	/**
	 * targetAudience
	 *
	 * The targetAudience attribute will accept an object of type AssociationTargetAudienceEntity.
	 */
	@Input({ required: true }) public readonly targetAudience: AssociationTargetAudienceEntity;
	/**
	 * showUnset
	 *
	 * The showUnset attribute will decide on showing the 'not set' tag.
	 */
	@Input() public showNotSet: boolean = false;
	/**
	 * clearFilter
	 *
	 * The clearFilter attribute will emit an event when the filter is cleared indicating which target group filter it is about.
	 */
	@Output() public clear: EventEmitter<'age'> = new EventEmitter<'age'>();

	public readonly i18nKeys: typeof I18nKeys = I18nKeys;
	public readonly associationTargetAudience: typeof AssociationTargetAudience = AssociationTargetAudience;
	public readonly clearable: WritableSignal<boolean> = signal(false);

	constructor(public readonly i18nService: NgxI18nService) {}

	public ngOnInit(): void {
		// Denis: When the clear EventEmitter has observers, set the clearable signal to true.
		this.clearable.set(this.clear?.observers?.length > 0);
	}
}
